import styled from 'styled-components';

export const DocumentContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderGray};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  min-width: 0;
`;

export const DocumentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
`;

export const DocumentHeaderLeft = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textBlack};
  flex: 1;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DocumentHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const DocumentContent = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textGray};
  flex: 1;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const DocumentFooter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  margin-top: auto;
  flex-wrap: wrap;
  overflow: hidden;
  min-width: 0;

  > div {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    white-space: nowrap;
    min-width: calc(50% - 12px);

    @media (min-width: 1200px) {
      min-width: auto;
    }
  }

  @media (max-width: 1199px) {
    gap: 12px;
  }
`;

export const Title = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.textGray};
  font-weight: 600;
  flex-shrink: 0;
`;

export const Value = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.textBlack};
  font-weight: 300;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
`; 